import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingsService } from 'src/app/services/account/settings.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { ModalOptionPanelComponent } from '../modal-option-panel/modal-option-panel.component';

@Component({
  standalone: true,
  selector: 'app-voice-command-error-dialog',
  templateUrl: './voice-command-error-dialog.component.html',
  imports: [CommonModule, ModalOptionPanelComponent],
  styleUrls: ['./voice-command-error-dialog.component.scss']
})
export class VoiceCommandErrorDialogComponent implements OnInit {

  public errorMsg: string;
  public notSupported: boolean = false;

  constructor(public dialogRef: MatDialogRef<VoiceCommandErrorDialogComponent>,
    public settingsService: SettingsService,
    public languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.errorMsg = data?.errorMsg || '';
    this.notSupported = !!data?.notSupported;
  }

  ngOnInit(): void {
    if (!this.notSupported) {
      setTimeout(() => {
        this.dialogRef.close();
      }, 5000);
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
